import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { menu, MenuRoutes } from '@/constants/menu';
import { store } from '@/store';

import { Item } from './components';
import styles from './Menu.module.scss';

export const Menu = observer(() => {
  const { t } = useTranslation();
  const location = useLocation();
  const menuItems = useMemo(
    () =>
      menu.map((item) => ({
        ...item,
        notification: '',
        name: t(item.name),
        disabledName: t('common.menu.soon'),
        id: item.name,
      })),
    [t],
  );

  useEffect(() => {
    store.menu.switch(location.pathname as MenuRoutes);
  }, [location.pathname]);

  return (
    <>
      {store.menu.isVisible && (
        <div className={clsx(styles.menu, 'in-row in-h-around')}>
          {menuItems.map((item) => (
            <Item {...item} key={item.id} />
          ))}
        </div>
      )}
    </>
  );
});
